import React, { useState, Fragment, useEffect} from "react";


const OrigEditRequest = (data) => {

    const [request, setRequest] = useState({
        apptName: data.items.appt_name,
        apptDate: data.items.appt_date,
        apptTime: data.items.appt_time,
        apptTimeTBD: data.items.appt_time_TBD,
        apptTimeZone: data.items.appt_timeZone,
        apptStreet: data.items.appt_street,
        apptCity: data.items.appt_city,
        apptState: data.items.appt_state,
        apptZip: data.items.appt_zip,
        comments: data.items.comments,
        apptLender:data.items.appt_lender,
        contactName: data.items.appt_contactName,
        contactPhone1: data.items.appt_contactPhone1,
        contactPhone2: data.items.appt_contactPhone2,
        contactEmail1: data.items.appt_contactEmail1,
        contactEmail2: data.items.appt_contactEmail2,
        fileNumber:data.items.fileNumber,
        scanBack: data.items.scanBack,
        transactionType: data.items.transactionType,
        financeType: data.items.financeType
    })
    const [changedData, setChangedData] = useState({})
    const [requireTime, setRequireTime] = useState(true)

    // Get today's date in YYYY-MM-DD format for date input min attribute
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    }

    const onChangeEvent = (evt) => {
        const value = evt.target.value;
        setRequest({
            ...request,
            [evt.target.id]: value
        })
        setChangedData({
            ...changedData,
            [evt.target.id]: value
        })
    }
    
    useEffect(() => {
        console.log(data.items)
        console.log(request['apptState'])
        setCheckBox(request['apptTimeTBD'])
        setScanBack(request['scanBack'])
        setTransactionType(request['transactionType'])
        setFinanceType(request['financeType'])
        document.getElementById(request['apptTimeZone']).selected = true
        const idArray = ['apptState']
        const stateArray = ['State', 'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'HI', 
        'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 
        'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 
        'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY']
        idArray.forEach(value => {
            const stateVar = document.getElementById(value)
            stateArray.forEach(value2 => {
                const option = document.createElement('option')
                option.innerHTML = value2
                if (request[value] == value2) {
                    console.log('it matched the state')
                    option.setAttribute('selected','selected')
                }
                stateVar.appendChild(option)
            })
        })
    },[]);
    //const stateVar = document.getElementById('certifiedState1Select')

    const setCheckBox = (initialValue) => {
        const checkboxArray = ['apptTimeTBD']
        console.log(initialValue)
        checkboxArray.forEach(value => {
            const checkBoxVar = document.getElementById(value)
            if (initialValue){
                if (initialValue != checkBoxVar.checked){
                    checkBoxVar.click()}
                }
        })
    }

    const setScanBack = (initialValue) => {
        if (initialValue === 'true') {
            var radioButton = document.querySelector("input[value='true']")
            radioButton.checked = true;
        }
        else {
            var radioButton = document.querySelector("input[value='false']")
            radioButton.checked = true;
        }
    }

    const setTransactionType = (initialValue) => {
        if (initialValue === '1') {
            var radioButton = document.querySelector("input[value='1']")
            radioButton.checked = true;
        }
        else if (initialValue === '2') {
            var radioButton = document.querySelector("input[value='2']")
            radioButton.checked = true;
        }
        else if (initialValue === '3') {
            var radioButton = document.querySelector("input[value='3']")
            radioButton.checked = true;
        }
        else if (initialValue === '4') {
            var radioButton = document.querySelector("input[value='4']")
            radioButton.checked = true;
        }
    }

    const setFinanceType = (initialValue) => {
        if (initialValue === '11') {
            var radioButton = document.querySelector("input[value='11']")
            radioButton.checked = true;
        }
        else if (initialValue === '12') {
            var radioButton = document.querySelector("input[value='12']")
            radioButton.checked = true;
        }
        else if (initialValue === '13') {
            var radioButton = document.querySelector("input[value='13']")
            radioButton.checked = true;
        }
        else if (initialValue === '14') {
            var radioButton = document.querySelector("input[value='14']")
            radioButton.checked = true;
        }
        else if (initialValue === '15') {
            var radioButton = document.querySelector("input[value='15']")
            radioButton.checked = true;
        }
        else if (initialValue === '16') {
            var radioButton = document.querySelector("input[value='16']")
            radioButton.checked = true;
        }
    }

    const updateTimeField = () => {

        if(requireTime){
          setRequireTime(false)
          setRequest({
            ...request,
            ['apptTime']: '00:00',
            ['apptTimeTBD'] : true
        })
            setChangedData({
            ...changedData,
            ['apptTime']: 'TBD',
            ['apptTimeTBD'] : true
        })
        }
        else{
          setRequireTime(true)
          setRequest({
            ...request,
            ['apptTime']: '',
            ['apptTimeTBD'] : false
        })
          setChangedData({
            ...changedData,
            ['apptTime']: '',
            ['apptTimeTBD'] : false
        })
        }
      }

    const addState = (evt) => {
        const value = evt.target.id
        setRequest({
            ...request,
            [value] : evt.target.value
        })
    }

    const convertToDate = (updatedTime) => {
        const date = new Date(updatedTime*1000)
        return date
    }

    function cancelEdit() {
        data.cancelEdit()
    }

    const onSubmitHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        // If editFlag is true, the preview button was selected and the updated form values are ready for review
        data.updateOrder({request, changedData})
    }

    return (
        <Fragment>
            <div className="card-section mt-4" id="myInput">
                <div className='card-section-header'>
                    <h2 className="card-section-title">Edit Existing Order</h2>
                    <div className="card-section-title-bar"></div>
                </div>
            <div className="card-section-body">
            <form onSubmit={(e)=>onSubmitHandler(e)} className="needs-validation">
             <div className="bg-neutral-50 rounded-xl border border-neutral-200 p-4 sm:p-5 mb-6">
              <h3 className="text-lg font-semibold text-neutral-800 mb-4 pb-2 border-b border-neutral-100">Order Details <span className="text-sm font-normal text-neutral-500">(* required field)</span></h3>
              <div className="mb-4">
                <label htmlFor="apptName" className='block text-sm font-medium text-neutral-700 mb-1'>Appointment Name *</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptName" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptName} required />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-4">
               <div>
                <label htmlFor="apptDate" className='block text-sm font-medium text-neutral-700 mb-1'>Date *</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptDate" onChange={(e)=>onChangeEvent(e)} type="date" value={request.apptDate} min={getTodayDate()} required/>
               </div>
               <div className="flex items-center gap-2 pt-6">
                    <input className="h-4 w-4 text-blue-600 border-neutral-300 rounded focus:ring-blue-500" type="checkbox" value="" id="apptTimeTBD" onChange={() => {updateTimeField()}}/>
                    <label className="text-sm font-medium text-neutral-700">Time TBD</label>
                </div>
               <div>
                {requireTime
                ?(<div><label htmlFor="apptTime" className='block text-sm font-medium text-neutral-700 mb-1'>Time *</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptTime" onChange={(e)=>onChangeEvent(e)} type="time" value={request.apptTime} required/></div>)
                : <div><label htmlFor="apptTime" className='block text-sm font-medium text-neutral-700 mb-1'>Time *</label><input className='w-full px-3 py-2 border border-neutral-300 rounded-lg bg-neutral-100' id='apptTimeTBD' value='TBD' readOnly/></div>}
               </div>
               <div>
                <label htmlFor="apptTimeZone" className='block text-sm font-medium text-neutral-700 mb-1'>Timezone</label>
                <select className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' aria-label='form-select-sm' id="apptTimeZone" onChange={(e)=>onChangeEvent(e)}>
                  <option value='ET' id='ET'>Eastern</option>
                    <option value='CT' id = 'CT' selected>Central</option>
                    <option value='MT' id='MT'>Mountain</option>
                    <option value='PT' id='PT'>Pacific</option>
                    <option value='HT' id='HT'>Hawaii</option>
                    <option value='AK' id='AK'>Alaska</option>
                  </select>
                </div>
              </div>
              <div className="mb-4">
                <label htmlFor="apptStreet" className='block text-sm font-medium text-neutral-700 mb-1'>Location of Appointment *</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptStreet" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptStreet} required />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 mb-4">
               <div>
                <label htmlFor="apptCity" className='block text-sm font-medium text-neutral-700 mb-1'>City *</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptCity" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptCity} required/>
               </div>
               <div>
               <label htmlFor="apptState" className='block text-sm font-medium text-neutral-700 mb-1'>State *</label>
                  <select className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' aria-label='form-select-sm' id="apptState" onChange={(e)=>addState(e)}></select>
               </div>
               <div>
                <label htmlFor="apptZip" className='block text-sm font-medium text-neutral-700 mb-1'>Zip Code *</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptZip" maxLength="5" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.apptZip} required/>
               </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
               <div>
                <label htmlFor="fileNumber" className='block text-sm font-medium text-neutral-700 mb-1'>File Number</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="fileNumber" onChange={(e)=>onChangeEvent(e)} type="text" value={request.fileNumber} />
               </div>
               <div>
                <label htmlFor="apptLender" className='block text-sm font-medium text-neutral-700 mb-1'>Lender</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="apptLender" onChange={(e)=>onChangeEvent(e)} type="text" value={request.apptLender} />
               </div>
               </div>
               <div className="border-t border-neutral-200 pt-4 mt-4">
                <p className="text-sm font-medium text-neutral-700 mb-3">SCAN BACK REQUIRED *</p>
                <div className="flex flex-wrap gap-4">
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="scanBack" id="scanBack" onChange={(e)=>onChangeEvent(e)} value={true} required/>
                        <span className="text-sm text-neutral-700">Required</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="scanBack" id="scanBack" onChange={(e)=>onChangeEvent(e)} value={false} required/>
                        <span className="text-sm text-neutral-700">Not Required</span>
                    </label>
                </div>
              </div>

              <div className="border-t border-neutral-200 pt-4 mt-4">
                <p className="text-sm font-medium text-neutral-700 mb-3">TYPE OF TRANSACTION *</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'1'} required/>
                        <span className="text-sm text-neutral-700">Purchase (Buyer Side)</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'2'} required/>
                        <span className="text-sm text-neutral-700">Refinance</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'3'} required/>
                        <span className="text-sm text-neutral-700">Seller Side Closing</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="transactionType" id="transactionType" onChange={(e)=>onChangeEvent(e)} value={'4'} required/>
                        <span className="text-sm text-neutral-700">Other (Warranty deed, single document, etc.)</span>
                    </label>
                </div>
              </div>

              <div className="border-t border-neutral-200 pt-4 mt-4">
                <p className="text-sm font-medium text-neutral-700 mb-3">TYPE OF FINANCING <span className="font-normal text-neutral-500">(Optional)</span></p>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'11'} />
                        <span className="text-sm text-neutral-700">FHA</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'16'} />
                        <span className="text-sm text-neutral-700">VA</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'12'} />
                        <span className="text-sm text-neutral-700">Conventional</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'13'} />
                        <span className="text-sm text-neutral-700">Reverse</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'14'} />
                        <span className="text-sm text-neutral-700">HELOC</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                        <input className="h-4 w-4 text-blue-600 border-neutral-300 focus:ring-blue-500" type="radio" name="financeType" id="financeType" onChange={(e)=>onChangeEvent(e)} value={'15'} />
                        <span className="text-sm text-neutral-700">Commercial</span>
                    </label>
                </div>
              </div>
              <div className="border-t border-neutral-200 pt-4 mt-4 mb-4">
               <label htmlFor="comments" className='block text-sm font-medium text-neutral-700 mb-1'>Additional Comments <span className="font-normal text-neutral-500">(max 400 characters)</span></label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="comments" maxLength='400' onChange={(e)=>onChangeEvent(e)} type="text" value={request.comments} />
              </div>
              <div className="mb-4">
               <label htmlFor="contactName" className='block text-sm font-medium text-neutral-700 mb-1'>Signer Contact Name</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="contactName" onChange={(e)=>onChangeEvent(e)} type="text" value={request.contactName} />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
               <div>
                <label htmlFor="contactPhone1" className='block text-sm font-medium text-neutral-700 mb-1'>Signer Contact Phone 1</label>
                    <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="contactPhone1" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.contactPhone1} />
               </div>
               <div>
                <label htmlFor="contactPhone2" className='block text-sm font-medium text-neutral-700 mb-1'>Signer Contact Phone 2</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="contactPhone2" onChange={(e)=>onChangeEvent(e)} type="tel" value={request.contactPhone2} />
               </div>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
               <div>
                <label htmlFor="contactEmail1" className='block text-sm font-medium text-neutral-700 mb-1'>Signer Email Address 1</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="contactEmail1" onChange={(e)=>onChangeEvent(e)} type="email" value={request.contactEmail1} />
               </div>
               <div>
                <label htmlFor="contactEmail2" className='block text-sm font-medium text-neutral-700 mb-1'>Signer Email Address 2</label>
                <input className='w-full px-3 py-2 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500' id="contactEmail2" onChange={(e)=>onChangeEvent(e)} type="email" value={request.contactEmail2} />
               </div>
              </div>
              </div>

                <div className='mt-6 flex gap-3'>
                    <input className='bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors cursor-pointer' type="submit" value="Update Order"/>
                    <button className='bg-neutral-200 hover:bg-neutral-300 text-neutral-800 font-medium py-2 px-6 rounded-lg transition-colors' type="button" onClick={() => cancelEdit()}>Cancel Edit</button>
                </div>
            </form>
            </div>
            </div>
        </Fragment>
        );
    }
export default OrigEditRequest;